module.exports = __webpack_public_path__ + "./docs/img/big-icon-tutorial.5eb87d2b5afedfb2c146da5c9241b3f4.svg";